// extracted by mini-css-extract-plugin
module.exports = {"statusActive":"index_statusActive__3-yhD","statusInactive":"index_statusInactive__30iGo"};